import styled from 'styled-components';

import { Text12 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const TimerText = styled(Text12)`
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
`;

export const TimerCountdown = styled(Text12)`
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
  font-weight: bold;
`;
